import { Component, OnInit } from '@angular/core';
import { faAt, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss']
})
export class BookingDetailsComponent implements OnInit {
  icons = {
    cancel: faTimes,
    close: faTimes,
    at: faAt
  };
  data: any;
  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions

  ) {
    this.data = this.options?.initialState
    console.log(this.data)
  }

  ngOnInit(): void {
  }

  close() {
    this.bsModalRef?.hide()
  }

}
